var map = {
	"./appAsset-Branding--TemplateEmail-admiral.svg": "bb9c",
	"./appAsset-Branding--TemplateEmail-classic.svg": "304c",
	"./appAsset-Branding--TemplateEmail-modern.svg": "272b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "12d4";